module.exports = fox._r("images/promo/footer-decor.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/footer-decor.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/footer-decor.png
// module id = 168
// module chunks = 2